import { Sparkles } from "lucide-react";
import { useScrollDeep } from "@/hooks/useScrollDeep";

const WHATSAPP_AUDIT_URL =
  "https://wa.me/918602265191?text=Hey%20Dynamic%20X%20Media%2C%20I%20want%20to%20claim%20my%20Free%20Marketing%20%26%20Branding%20Audit.%20Here%20are%20my%20details%3A%0A%0A-%20Name%3A%20%0A-%20Email%3A%20%0A-%20Company%3A%20%0A-%20Designation%3A";

export default function LeadFormFAB() {
  const deep = useScrollDeep(0.45);
  return (
    <a
      href={WHATSAPP_AUDIT_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="lead-form-fab"
      aria-label="Get a free audit on WhatsApp"
      className="group fixed bottom-6 right-24 z-50 inline-flex items-center gap-2 rounded-full bg-cta-solid px-5 py-3.5 text-white text-sm font-semibold glow-cta-light transition-all duration-500 hover:-translate-y-0.5"
      style={{
        opacity: deep ? 0 : 1,
        pointerEvents: deep ? "none" : "auto",
        transform: deep ? "translateY(20px) scale(0.85)" : "translateY(0) scale(1)",
      }}
    >
      <Sparkles className="h-4 w-4" />
      <span className="hidden sm:inline">Free Audit</span>
      <span className="sm:hidden">Audit</span>
    </a>
  );
}
